module.exports = __webpack_public_path__ + "img/brittleLava.d2ef45e0.jpg";